export default __webpack_public_path__ + "static/media/welcome.d724eb98.png";